import { render, staticRenderFns } from "./UnionPreview.vue?vue&type=template&id=921980e8&scoped=true&"
import script from "./UnionPreview.vue?vue&type=script&lang=js&"
export * from "./UnionPreview.vue?vue&type=script&lang=js&"
import style0 from "./UnionPreview.vue?vue&type=style&index=0&id=921980e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921980e8",
  null
  
)

export default component.exports